<div class="spinner-outline"><md-spinner></md-spinner></div>